module.exports = __webpack_public_path__ + "img/gallery13.bc4d0dbf.jpg";